/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const legalForms = [
  { label: "GmbH" },
  { label: "GmbH & Co. KG" },
  { label: "GmbH & Co. OHG" },
  { label: "gGmbH" },
  { label: "AG" },
  { label: "AG & Co. KG" },
  { label: "UG (haftungsbeschränkt)" },
  { label: "gUG (haftungsbeschränkt)" },
  { label: "OHG" },
  { label: "GbR" },
  { label: "Limited" },
  { label: "Limited & Co. KG" },
  { label: "Juristische Person des öffentlichen Rechts" },
  { label: "natürliche Person" },
  { label: "eingetragener Kaufmann" },
  { label: "SE" },
  { label: "KG" },
  { label: "AöR" },
  { label: "e.V." },
  { label: "UG (haftungsbeschränkt) & Co. KG" },
  { label: "eG" },
];

export default legalForms;
